"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssertionError = exports.assert = void 0;
var assert_1 = require("./assert");
Object.defineProperty(exports, "assert", { enumerable: true, get: function () { return assert_1.assert; } });
Object.defineProperty(exports, "AssertionError", { enumerable: true, get: function () { return assert_1.AssertionError; } });
//# sourceMappingURL=index.js.map